import styled from 'styled-components';

export const Content = styled.div`
    max-width: 600px;
    >hr{
        width: 100%;
        height: 0.1px;
        color: rgba(188, 191, 194, 0.2);
    }
    @media(max-width: 767px){
        width: 122%;
    }

    .property-pre-selected {
        padding: 10px;
        background-color: #f5f5f5;
        border: 1px solid #ddd;
        border-radius: 4px;
        margin-bottom: 10px;

        strong {
            display: block;
        }

        p {
            font-size: 12px;
            color: #666;
            margin: 5px 0 0 0;
        }
    }
`;

export const TitleContainer = styled.div`
    padding: 24px 300px 24px 24px;
    @media(max-width: 767px){
        padding: 24px 130px 24px 24px;
    }
`;

export const FormContainer = styled.form`
    padding: 12px 24px 0 24px;
    position: relative;
    >p{
        margin: 16px 0 14px;
    }
    >input{
        width: 100%;
        padding: 14px 12px;
        border: 0;
        border-bottom: 1px solid #B6B6B6;
        cursor: default;
    }
    #users{
        width: 90%;
        height: 210px;
        max-height: 210px;
        overflow-y: auto;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        position: fixed;
        left: 50;
        top: 25;
        z-index: 10000;
        background: #FFFFFF;
        border: 1px solid #B6B6B6;
        >button{
            padding: 12px 16px;
            height: 35px;
            width: 100%;
            font-size: 14px;
            text-align: start;
            border: none;
            background: white;
            cursor: pointer;
            transition: all 0.2s;
            &:hover{
                background: #F9F9F9;
            }
        }
    }
    .css-2b097c-container{
        width: 100%;
        &:last-child{
            margin-bottom: 64px;
        }
    }
    .css-yk16xz-control{
        border-color: #04c5ff;
    }
    .css-1okebmr-indicatorSeparator{
        display: none;
    }
    .MuiAutocomplete-root{
        margin-bottom: 16px;
    }
    @media(max-width: 767px){
        >input{
            width: 100%;
        }
        #users{
            width: 70%;
            height: 210px;
            max-height: 210px;
        }
        .css-2b097c-container{
            width: 100%;
        }
    }
`;

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    input {
        margin-right: 8px;
        accent-color: #dd6435;
        cursor: pointer;
    }

    label {
        cursor: pointer;
        color: #475569;
        font-size: 14px;
        user-select: none;
    }
`;

export const ButtonsContainer = styled.div`
    width: 100%;
    padding: 18px 24px 6px;
    display: flex;
    justify-content: flex-end;

    >button{
        background-color: #04c5ff;
        border: 0;
        border-radius: 4px;
        padding: 12px 24px;
        color: #FFF;
        cursor: pointer;
        font-size: 14px;
        min-width: 120px;
    }

    >p{
        background-color: transparent;
        border: 1px solid #04c5ff;
        border-radius: 4px;
        padding: 12px 24px;
        color: #04c5ff;
        margin: 0;
        min-width: 120px;
        text-align: center;
    }

    @media(max-width: 767px){
        padding: 18px 16px 6px;
        justify-content: center;
        
        >button, >p{
            width: 100%;
            max-width: 200px;
            margin-left: 0;
        }
    }

    @media(max-width: 480px){
        >button, >p{
            width: 100%;
            max-width: none;
        }
    }
`;

export const ModalStyles = styled.div`
  .modalSchedule {
    border-radius: 8px;
    padding: 0;
    margin: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 600px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    
    @media (max-width: 767px) {
      width: 95%;
      max-height: 95vh;
    }
  }

  .react-responsive-modal-overlay {
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;